import Alpine from 'alpinejs';
import { AlpineComponentTryba } from '../../../scripts/alpine/include/global';
document.addEventListener('alpine:init', () => {
    Alpine.data('initProgressBar', (): AlpineComponentTryba => {
        return {
            init() {
                const supportsScrollTimeline = CSS.supports(
                "animation-timeline: scroll()"
                );

                window.addEventListener("scroll", () => {
                    const header = document.querySelector("header");
                    if(header?.classList.contains("!top-0")) {
                        if (this.$store.global.isMobile) {
                            this.$refs.progressbar.style.top = `122px`;
                        } else {
                            this.$refs.progressbar.style.top = `148px`;
                        }
                    } else {
                        if (this.$store.global.isMobile) {
                            this.$refs.progressbar.style.top = `0px`;
                        } else {
                            this.$refs.progressbar.style.top = `71px`;
                        }
                    }
                })

                if (!supportsScrollTimeline) {
                    const progress : HTMLElement | null = document.querySelector(".progress");
                    if (!progress) {
                        return;
                    }

                    window.addEventListener("scroll", () => {
                        const scrollTop = window.scrollY;

                        const height =
                        document.documentElement.scrollHeight - window.innerHeight;

                        const percent = (scrollTop / height) * 100;

                        progress.style.width = percent + "%";
                    });
                }
            },
        };
    });
});
